const DEFAULT_ROOT_DOMAIN = 'prohaul.ai';
const ROOT_DOMAIN = import.meta.env?.VITE_ROOT_DOMAIN || DEFAULT_ROOT_DOMAIN;
const RESERVED_SUBDOMAINS = new Set(['www', 'app']);
const SLUG_SHAPE = /^[a-z0-9](?:[a-z0-9-]{0,38}[a-z0-9])?$/;

// Parses window.location.hostname (NOT location.host -- that includes the
// port) into a candidate carrier slug, or null if this host isn't a
// tenant-scoped subdomain. Used to decide whether a visitor landed on
// e.g. gftrucklines.prohaul.ai (a specific carrier's branded sign-in) vs
// the bare apex/www/app/localhost/preview hosts (generic multi-tenant gate).
//
// rootDomain is a parameter (not just baked in) so tests can call this
// without depending on import.meta.env, and so a staging root domain could
// be passed explicitly later without touching this file.
export function getTenantSlugFromHostname(hostname, rootDomain = ROOT_DOMAIN) {
  if (!hostname) return null;
  const host = hostname.toLowerCase().trim();

  if (host === 'localhost') return null;
  if (/^(\d{1,3}\.){3}\d{1,3}$/.test(host)) return null;       // bare IPv4
  if (host.endsWith('.up.railway.app')) return null;            // Railway preview domains
  if (host === rootDomain) return null;                         // bare apex

  const suffix = `.${rootDomain}`;
  if (!host.endsWith(suffix)) return null;                      // any other/custom domain

  const prefix = host.slice(0, -suffix.length);
  if (!prefix || prefix.includes('.')) return null;             // empty, or nested (foo.bar.prohaul.ai)
  if (RESERVED_SUBDOMAINS.has(prefix)) return null;              // www / app
  if (!SLUG_SHAPE.test(prefix)) return null;                     // not slug-shaped

  return prefix;
}
